import { useEffect, useMemo, useState } from 'react'
import "./pagerComponent.css"
import { Pager } from "components/types/Api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

interface pagerProps {
    pager: Pager
    onpageChange?: any
    classCss?: string
}

export const PagerComponent = ({ pager, onpageChange, classCss }: pagerProps) => {
    const [page, setPage] = useState(pager.pageNum);

    useEffect(() => {
        setPage(pager.pageNum + 1);
    }, [pager])

    const netxbutton = useMemo(() => {
        return <button disabled={page === pager.totalPages || pager.totalPages === 0} className="" onClick={() => {
            if (page + 1 <= pager.totalPages) {
                setPage(page + 1);
                onpageChange(page)
            } else {
                setPage(pager.totalPages);
                onpageChange(pager.totalPages - 1)
            }
        }}>
            <FontAwesomeIcon color='white' icon={faChevronRight} />
        </button>
    }, [pager, page, onpageChange])

    const prevbutton = useMemo(() => {
        return <button disabled={page <= 1} className="" onClick={() => {
            if (page - 1 >= 1) {
                setPage(page - 1);
                onpageChange(page - 2)
            } else {
                setPage(1);
                onpageChange(0)
            }
        }}>
            <FontAwesomeIcon color='white' icon={faChevronLeft} />
        </button>
    }, [pager, page, onpageChange])

    // const inputPager = useMemo(() => {
    //     return <input className='form-input' readOnly min={1} max={pager.totalPages} value={pager.totalPages === 0 ? 0 : page}
    //         onChange={(v) => {
    //             setPage(Number(v))
    //             onpageChange(Number(v))
    //         }} />
    // }, [pager, page, onpageChange])


    return (
        <div className={`${classCss} pager col-12 pager-wrapper`}>
            <div className="pager-wrapper justify-content-end">
                {prevbutton}
                {/* <span className="mx-2">Page</span> */}
                {/* {inputPager} */}
                <span className="mx-2">Page {pager?.totalPages === 0 ? 0 : page} of {pager?.totalPages}</span>
                {netxbutton}
            </div>
        </div>
    )
}